// extracted by mini-css-extract-plugin
export default {"segmentPicker":"_32oBYmJ_","inputContainer":"_13KHqCi1","input":"_1_VXgCMz","label":"_3PxMqEe2"};